import React from 'react';
import { Descriptions, DescriptionsProps, Layout } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../hooks/store';

function Profile() {
    const { t } = useTranslation();
    const user = useAppSelector((state) => state.global.loggedUser);

    if (!user) {
        return null;
    }

    const items: DescriptionsProps['items'] = [
        {
            label: t('user.name'),
            children: <p>{user.firstName}</p>,
        },
        {
            label: t('user.surname'),
            children: <p>{user.lastName}</p>,
        },
        {
            label: t('user.email'),
            children: <p>{user.email}</p>,
        },
    ];

    return (
        <Layout.Content style={{ display: 'flex', overflow: 'auto' }}>
            <Descriptions column={{ xs: 1, sm: 1, md: 2, lg: 3, xl: 3, xxl: 3 }} bordered items={items} size="small" />
        </Layout.Content>
    );
}

export default Profile;
